import { render, staticRenderFns } from "./TransactionConsent.vue?vue&type=template&id=203fbb40&scoped=true"
import script from "./TransactionConsent.vue?vue&type=script&lang=js"
export * from "./TransactionConsent.vue?vue&type=script&lang=js"
import style0 from "./TransactionConsent.vue?vue&type=style&index=0&id=203fbb40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203fbb40",
  null
  
)

export default component.exports